// Il backend serializza gli enum come stringa (JsonStringEnumConverter),
// quindi "value" deve corrispondere al nome del membro C# di StatoMezzo.
export const STATI_MEZZO = [
    { label: "Attivo", value: "Attivo" },
    { label: "In manutenzione", value: "InManutenzione" },
    { label: "Fuori servizio", value: "FuoriServizio" },
    { label: "Dismesso", value: "Dismesso" },
];

const COLORI_STATO = {
    Attivo: "success",
    InManutenzione: "warning",
    FuoriServizio: "error",
    Dismesso: "grey",
};

export function coloreStato(stato) {
    return COLORI_STATO[stato] || "grey";
}

export function etichettaStato(stato) {
    return (STATI_MEZZO.find(s => s.value === stato) || {}).label || "";
}
